import React from 'react'
import { Main, MainBody, MainTop, MainTopTitle } from '@/components/Layout'
import Resx from '@/components/Resx'

export class EntityNotFound extends React.Component {
  render () {
    const url = decodeURIComponent(window.location.search.replace('?url=', ''))
    return (
      <Main>
        <MainTop>
          <MainTopTitle>
            <Resx name='Common.DetailNotFound' />
          </MainTopTitle>
        </MainTop>

        <MainBody transparent>
          <div><Resx name='Common.DetailNotFound' /></div>
          <div><Resx name='Common.RequestedUrl' />: {url}</div>
        </MainBody>
      </Main>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/EntityNotFound.js